import { computed } from 'vue';
import { useStore } from '@/components/common/store';
import { useTranslations } from 'src/storybook/src/composables/translations';
import { getFilters } from 'src/services/filters';

/**
 * A composable function that provides the active filters and their count.
 */
export function useFilters() {
	const translate = useTranslations();
	const store = useStore();
	const activeFilters = computed(() => getFilters(store, translate));
	const filtersCount = computed(() => activeFilters.value.length);
	return {
		activeFilters,
		filtersCount,
	};
}
